import { Navigate } from 'react-router-dom';

/**
 * Componente de Proteção de Rotas Administrativas
 * 
 * Verifica se o usuário está autenticado antes de permitir acesso
 * ao painel administrativo.
 */
export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  
  // Se não houver token, redireciona para login
  if (!token) {
    return <Navigate to="/admin-painel-gestao/login" replace />;
  }
  
  // Se houver token, permite acesso
  return children;
};

/**
 * Componente de Redirecionamento de Login
 * 
 * Se o usuário já está autenticado e tenta acessar a página de login,
 * redireciona automaticamente para o dashboard.
 */
export const LoginRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  
  // Se já está autenticado, redireciona para dashboard
  if (token) {
    return <Navigate to="/admin-painel-gestao/dashboard" replace />;
  }
  
  // Se não está autenticado, mostra a página de login
  return children;
};
